const atualizarCargos = (state, cargos) => {
    state.cargos = cargos;
}

const atualizarCargo = (state, cargo) => {
    state.cargo = cargo;
}

export default {
    atualizarCargos,
    atualizarCargo
}